import { Directive, HostListener, ElementRef, OnInit, OnDestroy } from '@angular/core';
import * as textMask from 'vanilla-text-mask/dist/vanillaTextMask.js';
import { NgModel } from '@angular/forms';
import * as moment from 'moment';

@Directive({
  selector: '[ngModel][rteDatePickerWithMask]',
  providers: [NgModel]
})
export class DatePickerWithMaskDirective implements OnInit, OnDestroy {

  DATE_MASK = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  maskedInputController;

  constructor(private element: ElementRef, private ngModel: NgModel) { }

  ngOnInit() {
    setTimeout(() => {
      const elementRef = this.element.nativeElement;

      if (elementRef != null) {

        this.maskedInputController = textMask.maskInput({
          inputElement: elementRef,
          mask: this.DATE_MASK
        });
      }
    });
  }

  ngOnDestroy() {
    if (this.maskedInputController != null) {
      this.maskedInputController.destroy();
    }
  }

  @HostListener('keyup', ['$event'])
  onKeyup(event: KeyboardEvent) {
    const value: string = (event.target as any).value;
    moment.locale('pt-br');

    if (value && value.length >= 10 && !value.includes('_')) {
      const aux = moment(value, 'DD/MM/YYYY');

      if (aux.isValid()){
        this.ngModel.update.emit(aux.toDate());
      }
    }
  }
}
